import { EditIdentityPanel } from '@features/profile/components/edit-identity-panel/EditIdentityPanel';
import { useProfileNavigation } from '@features/profile/hooks/use-profile-navigation/useProfileNavigation';
import * as React from 'react';

const EditIdentityRoute = React.memo((): React.ReactElement => {
  const { navigateToPersonalInformation } = useProfileNavigation();

  return <EditIdentityPanel onClose={navigateToPersonalInformation} />;
});

EditIdentityRoute.displayName = 'EditIdentityRoute';

export { EditIdentityRoute };
